var _path, _path2, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNewDefaultAvatar = function SvgNewDefaultAvatar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 78C60.539 78 77.9999 60.5391 77.9999 39C78 17.4609 60.5391 0 39 0C17.4609 0 -8.83105e-06 17.4609 -1.97247e-05 39C-3.06184e-05 60.5391 17.4609 78 38.9999 78Z",
    fill: "url(#paint0_linear_11852_66683)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11852_66683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 72,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75C58.8822 75 75 58.8822 75 39C75 19.1177 58.8823 3 39 3C19.1178 3 2.99999 19.1177 2.99998 39C2.99997 58.8822 19.1177 75 39 75Z",
    fill: "url(#paint1_linear_11852_66683)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11852_66683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0243 45.3234C52.1396 45.3234 54.1682 46.1923 55.664 47.7389C57.1597 49.2856 58 51.3833 58 53.5706L57.9995 71.8365C57.9995 77.1842 55.9451 82.3129 52.2882 86.0943C48.6313 89.8756 43.6714 92 38.4998 92C33.3281 92 28.3683 89.8756 24.7113 86.0943C21.0544 82.3129 19 77.1842 19 71.8365L19.0005 53.5706C19.0005 51.3833 19.8408 49.2856 21.3365 47.7389C22.8322 46.1923 24.8609 45.3234 26.9762 45.3234H50.0243ZM38.4896 16C40.1189 16 41.7322 16.3318 43.2374 16.9765C44.7427 17.6213 46.1104 18.5662 47.2625 19.7575C48.4145 20.9488 49.3284 22.3631 49.9519 23.9195C50.5754 25.476 50.8963 27.1443 50.8963 28.829C50.8963 30.5137 50.5754 32.1819 49.9519 33.7384C49.3284 35.2949 48.4145 36.7092 47.2625 37.9004C46.1104 39.0917 44.7427 40.0367 43.2374 40.6814C41.7322 41.3261 40.1189 41.658 38.4896 41.658C35.1991 41.658 32.0434 40.3063 29.7167 37.9004C27.39 35.4945 26.0829 32.2314 26.0829 28.829C26.0829 25.4265 27.39 22.1634 29.7167 19.7575C32.0434 17.3516 35.1991 16 38.4896 16Z",
    fill: "#3F2FAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11852_66683",
    x1: 28.4698,
    y1: -0.721683,
    x2: 42.7633,
    y2: 129.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6655D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6655D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11852_66683",
    x1: 29.2799,
    y1: 2.33383,
    x2: 42.4739,
    y2: 122.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6655D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6655D1"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewDefaultAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-default-avatar.fbca0f72.svg";
export { ForwardRef as ReactComponent };